module.exports = __webpack_public_path__ + "static/media/Logo-2-zlg.74a4a86e.png";